export default __webpack_public_path__ + "assets/images/1c844a43ec882fc751607ced72f5611b.png";